import { UserTabs } from "../shared/Tabs/Tabs";
import CommunicationLogsGrid from "./CommunicationLogsGrid/CommunicationLogsGrid";
import BpCommunicationLogsGrid from "./CommunicationLogsGrid/BpCommunicationLogsGrid";
import { useNavigate, useParams } from "react-router-dom";

function CommunicationLogs() {
  const { tabId } = useParams<{ tabId: string }>();
  const navigate = useNavigate();
  const tabIndex = Number(tabId);
  const handleTabChange = (tabIndex: number) => {
    navigate(`/communicationLogs/${tabIndex}`);
  };
  return (
    <>
      <UserTabs
        value={tabIndex}
        items={["Notification Logs", "BP Communication Logs"]}
        handleChange={(value) => {
          handleTabChange(value);
        }}
      />

      <div className="communication-logs-wrapper clinic-grid-wrapper overflow-auto d-flex flex-column">
        {tabIndex === 0 && <CommunicationLogsGrid />}
        {tabIndex === 1 && <BpCommunicationLogsGrid />}
      </div>
    </>
  );
}

export default CommunicationLogs;
